<template>
  <div>
    <div class="grey lighten-5 cbg-white-container">
      <v-row>
        <v-col v-if="permissions.includes('CAN_CREATE_MOBILE_VERSION')" cols="12" md="2" sm="3">
          <div class="mt-3 ml-4">
            <v-btn class="btn btn-primary mr-4 mt-4" @click="createMobileVersion()">Create</v-btn>
          </div>
        </v-col>

        <v-col cols="11" md="3" class="mb-3 xs-ml-15 xs-mr-15" sm="8">
          <div class="position-relative">
            <label for>Filter by Platform</label>
            <select @change="selectPlatform()" name id class="form-control" v-model="platform">
              <option value>ALL</option>
              <option value="ANDROID">ANDROID</option>
              <option value="IOS">IOS</option>
            </select>
            <span class="drop-icon">
              <i aria-hidden="true" class="v-icon mdi mdi-menu-down theme--light position-absolute"></i>
            </span>
          </div>
        </v-col>
      </v-row>

      <loader v-if="showLoader"></loader>
      <v-col cols="12">
        <div class="table-div overflow-auto">
          <table class="table userlistTable small-table-width">
            <thead>
              <tr class="table-success">
                <th scope="col">Platform</th>
                <th scope="col">Version</th>
                <th scope="col">Is Force</th>
                <th scope="col">Description</th>
                <th scope="col" v-if="permissions.includes('CAN_DELETE_MOBILE_VERSION')">Action</th>
              </tr>
            </thead>
            <tbody v-if="!isEmpty">
              <tr v-for="(item, index) in mobileVersionLists" :key="index">
                <td>
                  <div>{{ item.platform }}</div>
                </td>
                <td>
                  <div>{{ item.version }}</div>
                </td>
                <td>
                  <div>{{ item.is_forced }}</div>
                </td>

                <td>
                  <div>{{ item.description }}</div>
                </td>
                <td v-if="permissions.includes('CAN_DELETE_MOBILE_VERSION')">
                  <div>
                    <v-btn @click="deleteData(item._id)" class="btn btn-danger mr-3">Delete</v-btn>
                  </div>
                </td>
              </tr>
              <tr></tr>
            </tbody>
            <tbody v-if="isEmpty">
              <tr>
                <td colspan="5">
                  <h2 class="text-center">No Data Found</h2>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-col>
      <mobile-version-create
        v-if="openCreateForm"
        :openCreateForm="openCreateForm"
        @close="closeModal"
        @getMobileVersionsApiCall="getMobileVersions"
      ></mobile-version-create>
    </div>
    <div class="text-center" v-if="mobileVersionLists.length > 0">
      <v-pagination
        v-model="page"
        :length="totalPage"
        :total-visible="5"
        prev-icon="mdi-menu-left"
        next-icon="mdi-menu-right"
      ></v-pagination>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
const loader = () => import("@/components/loader.vue");
const mobileVersionCreate = () =>
  import("@/components/modals/mobileVersionCreate.vue");
import { mapGetters } from "vuex";
export default {
  components: {
    loader,
    mobileVersionCreate
  },
  computed: {
    ...mapGetters({
      permissions: "getPermissions"
    })
  },
  data() {
    return {
      isEmpty: false,
      openCreateForm: false,
      showLoader: false,
      platform: "",
      page: 1,
      totalPage: 0,
      mobileVersionLists: [],
      iosOccurance: 0,
      androidOccurance: 0
    };
  },
  mounted() {
    this.getMobileVersions();
  },
  methods: {
    // close modal
    closeModal() {
      this.openCreateForm = false;
    },

    // select platform event
    selectPlatform() {
      this.page = 1;
      this.getMobileVersions();
    },

    // getMobileVersions Data
    getMobileVersions() {
      this.showLoader = true;
      if (this.platform === undefined || this.platform === "") {
        var params = {
          page: this.page,
          record_per_page: 10
        };
      } else {
        var params = {
          page: this.page,
          record_per_page: 10,
          platform: this.platform
        };
      }
      let url = `${config.BASE_URL}api/v2/admin/mobile-versions`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.showLoader = false;
          if (response.body.data.list.length) {
            this.isEmpty = false;
            this.mobileVersionLists = response.body.data.list;
            if (this.page === 1) {
              this.iosOccurance = 0;
              this.androidOccurance = 0;
            }
            this.mobileVersionLists.map(el => {
              if (this.iosOccurance === 0 && el.platform === "IOS") {
                el.isDeleted = true;
                this.iosOccurance++;
              }
              if (this.androidOccurance === 0 && el.platform === "ANDROID") {
                el.isDeleted = true;
                this.androidOccurance++;
              }
            });
          } else {
            this.isEmpty = true;
            this.mobileVersionLists = [];
          }

          this.totalPage = response.body.data.count / 10;
          if (response.body.data.count % 10 !== 0)
            this.totalPage = parseInt(JSON.stringify(this.totalPage)) + 1;
        }
      });
    },

    // delete data event
    deleteData(id) {
      this.$swal({
        title: "Are you sure?",
        text: "you want to delete this data!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No"
      }).then(result => {
        if (result.isConfirmed) {
          let url = `${config.BASE_URL}api/v2/admin/mobile-versions/${id}`;
          this.$http.delete(url).then(res => {
            if (res.data.status) {
              this.$swal({
                text: " Deleted sucessfully",
                icon: "success",
                allowOutsideClick: false,
                showCancelButton: false,
                confirmButtonText: "Ok"
              });
              this.getMobileVersions();
            }
          });
        }
      });
    },

    // modal open event
    createMobileVersion() {
      this.page = 1;
      this.platform = "";
      this.openCreateForm = true;
    }
  },
  watch: {
    page: function(newVal) {
      if (newVal) {
        this.getMobileVersions();
      }
    }
  }
};
</script>